import React from 'react'
import './about.css'
import Me from '../../assets/me-about.jpg'
import {FaAward} from 'react-icons/fa'
import  {FiUsers} from 'react-icons/fi'
import  {VscFolderLibrary} from 'react-icons/vsc'

function About() {
  return (
    <section id='about'>
      <h5> Get To Know</h5> 
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={Me} alt="About Image" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>3 Monthes Working</small>
            </article>

            <article className='about__card'>
              <FiUsers className='about__icon'/>
              <h5>Clients </h5>
              <small>+20 In Tunisia</small>
            </article>

            <article className='about__card'>
              <VscFolderLibrary className='about__icon'/>
              <h5>Projects</h5>
              <small>+6 Completed</small>
            </article>
          </div>
          <p>IT professional with a passion for technological innovation and a solid experience in solving complex problems. Expert in software development and project management, I am constantly looking for new opportunities to apply my advanced technical skills. My collaborative approach and my ability to communicate effectively allow me to work in a team while providing innovative solutions. Always eager to learn,
             I stay on the lookout for the latest trends and technologies in the field.</p>
<a href='#contact' className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
      </section>
  )
}

export default About